<app-page-header title="Közérdekű adatok"></app-page-header>

<div class="content my-3 col-lg-10 mx-auto">
  <app-accordion title="1. Szervezeti, személyzeti adatok">
    <ul>
      <li>
        <a routerLink="/main-council/officers"
          >1.1 Kapcsolat, szervezet, vezetők</a
        >
      </li>
      <li>
        <a (click)="noData('A felügyelt költségvetési szervek')"
          >1.2 A felügyelt költségvetési szervek</a
        >
      </li>
      <li>
        <a (click)="noData('Gazdálkodó szervezetek')"
          >1.3 Gazdálkodó szervezetek</a
        >
      </li>
      <li><a (click)="noData('Közalapítványok')">1.4 Közalapítványok</a></li>
      <li><a (click)="noData('Lapok')">1.5 Lapok</a></li>
      <li>
        <a routerLink="/main-council/seconded">
          1.6 Felettes, felügyeleti, törvényességi ellenőrzést gyakorló szerv
        </a>
      </li>
      <li>
        <a (click)="noData('Költségvetési szervek')">
          1.7 Költségvetési szervek
        </a>
      </li>
    </ul>
  </app-accordion>
  <app-accordion title="2.Tevékenységre, működésre vonatkozó adatok">
    <ul>
      <li>
        <a routerLink="/main-council/main-tasks">
          2.1 A szerv alaptevékenysége, feladat-és hatásköre
        </a>
      </li>
      <li>
        <a
          (click)="
            noData('A hatósági ügyek intézésének rendjével kapcsolatos adatok')
          "
        >
          2.2 A hatósági ügyek intézésének rendjével kapcsolatos adatok
        </a>
      </li>
      <li>
        <a (click)="noData('Közszolgáltatások')">2.3 Közszolgáltatások</a>
      </li>
      <li>
        <a (click)="noData('A szerv nyílvántartásai')"
          >2.4 A szerv nyílvántartásai</a
        >
      </li>
      <li>
        <a (click)="noData('Nyílvános kiadványok')">2.5 Nyílvános kiadványok</a>
      </li>
      <li>
        <a routerLink="/main-council/documents">2.6 Döntéshozatal, ülések</a>
      </li>
      <li>
        <a routerLink="/main-council/documents">
          2.7 A szerv döntései, koncepciók, tervezetek, javaslatok
        </a>
      </li>
      <li><a routerLink="/main/competitions">2.8 Pályázatok</a></li>
      <li><a routerLink="/main/news">2.9 Hirdetmények</a></li>
      <li>
        <a routerLink="/main-council/council-information">
          2.10 Közérdekű adatok igénylése</a
        >
      </li>
      <li>
        <a (click)="noData('Nyílvános kiadványok')">2.11 Közzétételi listák</a>
      </li>
    </ul>
  </app-accordion>
  <app-accordion title="3. Gazdálkodási adatok">
    <app-accordion title="3.1 A működés törvényessége, ellenőrzések">
      <ul>
        <li>
          <a (click)="noData('Vizsgálatok, ellenőrzések listája')"
            >3.1.1 Vizsgálatok, ellenőrzések listája</a
          >
        </li>
        <li>
          <a (click)="noData('Az Állami Számvevőszék ellenőrzései')"
            >3.1.2 Az Állami Számvevőszék ellenőrzései</a
          >
        </li>
        <li>
          <a (click)="noData('Egyéb ellenőrzések, vizsgálatok')"
            >3.1.3 Egyéb ellenőrzések, vizsgálatok</a
          >
        </li>
        <li>
          <a (click)="noData('A működés eredményessége, teljesítmény')"
            >3.1.4 A működés eredményessége, teljesítmény</a
          >
        </li>
        <li>
          <a (click)="noData('Működési statisztika')"
            >3.1.5 Működési statisztika</a
          >
        </li>
      </ul>
    </app-accordion>
    <app-accordion title="3.2 Költségvetések, beszámolók">
      <ul>
        <li>
          <a routerLink="/main-council/documents/Rendeletek"
            >3.2.1 Számviteli beszámolók</a
          >
        </li>
        <li>
          <a routerLink="/main-council/documents/Programok"
            >3.2.2 Éves költségvetések</a
          >
        </li>
        <li>
          <a routerLink="/main-council/documents/Programok"
            >3.2.3 A költségvetés végrehajtása</a
          >
        </li>
      </ul>
    </app-accordion>
    <app-accordion title="3.3 Működés">
      <ul>
        <li>
          <a routerLink="/main-council/officers">3.3.1 A foglalkoztatottak</a>
        </li>
        <li>3.3.2 Támogatások</li>
        <li>
          <a routerLink="/main-council/documents/szerzodesek">
            3.3.3 Szerződések</a
          >
        </li>
        <li><a (click)="noData('Koncessziók')">3.3.4 Koncessziók</a></li>
        <li>
          <a (click)="noData('Egyéb kifizetések')">3.3.5 Egyéb kifizetések</a>
        </li>
        <li>
          <a (click)="noData('Európai Unió által támogatott fejlesztések')"
            >3.3.6 Európai Unió által támogatott fejlesztések</a
          >
        </li>
        <li>
          <a routerLink="/mian-council/documents/kozbeszerzesek"
            >3.3.7 Közbeszerzések</a
          >
        </li>
      </ul>
    </app-accordion>
  </app-accordion>
</div>
